import axios from "axios";
import { getSession } from "next-auth/react";

const API_URL = "https://api.dev.yolk.coach/_internal/app";
export const clientFetcher = axios.create({
  baseURL: process.env.NEXT_PUBLIC_YOLK_API_URL || API_URL,
});

clientFetcher.interceptors.request.use(async (config) => {
  const session = await getSession();

  if (session?.accessToken) {
    config.headers.set("Authorization", `Bearer ${session.accessToken}`);
  }

  if (!(config.data instanceof FormData)) {
    config.headers.set("Content-Type", "application/json");
  }
  config.headers.set("Accept", "application/json");

  return config;
});
